import { render, staticRenderFns } from "./notification-list-menu.vue?vue&type=template&id=2eaec37b&"
import script from "./notification-list-menu.vue?vue&type=script&lang=js&"
export * from "./notification-list-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports